import { useEffect, useState } from 'react'
import { BarChart3, Clock3, Inbox, Mail, Users } from 'lucide-react'
import './HomeOutcomes.css'

const outcomes = [
  { title: 'Protect opportunities', description: 'See customer emails before valuable interest goes cold.', icon: Inbox },
  { title: 'Improve follow-through', description: 'Find where replies and follow-ups are taking too long.', icon: Clock3 },
  { title: 'Build accountability', description: 'See how customer-facing email work moves through your team.', icon: Users },
  { title: 'Protect reputation', description: 'Improve consistency in the communication customers experience.', icon: BarChart3 },
]

export function HomeOutcomes() {
  const [{ selected, revision }, setSelection] = useState({ selected: 0, revision: 0 })
  const selectOutcome = (index: number) => setSelection(current => ({ selected: index, revision: current.revision + 1 }))

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setSelection(current => ({ selected: (current.selected + 1) % outcomes.length, revision: current.revision + 1 }))
    }, 4000)
    return () => window.clearTimeout(timer)
  }, [selected, revision])
  const outcome = outcomes[selected]
  const Icon = outcome.icon

  return <aside className="home-outcomes" aria-label="Explore Mail Percent outcomes">
    <div className="home-outcomes-orbit" role="group" aria-label="Explore an outcome by hovering or focusing its icon">
      <div className="home-outcomes-ring outer"/>
      <div className="home-outcomes-ring inner"/>
      <div className="home-outcomes-axis horizontal"/>
      <div className="home-outcomes-axis vertical"/>
      <div className="home-outcomes-core" aria-hidden="true">
        {outcomes.map(({ title, icon: Icon }, index) => <Icon key={title} className={`home-outcomes-core-icon${selected === index ? ' active' : ''}`} size={52} strokeWidth={1.4}/>)}
      </div>
      {outcomes.map(({title, icon: NodeIcon}, index) => <button
        key={title}
        type="button"
        className={`home-outcomes-node node-${index}${selected === index ? ' selected' : ''}`}
        aria-label={title}
        aria-pressed={selected === index}
        onMouseEnter={() => selectOutcome(index)}
        onFocus={() => selectOutcome(index)}
        onClick={() => selectOutcome(index)}
      ><NodeIcon size={26} aria-hidden="true"/></button>)}
      <span className="home-outcomes-mail" aria-hidden="true"><Mail size={14}/>Your customer emails</span>
      <span className="home-outcomes-spark"/>
    </div>
    <div className="home-outcomes-story" aria-live="off" aria-atomic="true">
      <h2>{outcome.title}</h2>
      <p>{outcome.description}</p>
    </div>
  </aside>
}
